module.exports = __webpack_public_path__ + "img/archimed.png";